import view from './view.html';

/* @ngInject */
export default function (OnlineUsersService, AuthService) {
	return {
		restrict: 'E',
		template: view,
		replace:  true,
		link:     (scope) => {
			scope.update = function () {
				scope.members = Object.values(OnlineUsersService.getMembers())
				                      .map((member) => {
					                      let type = 'Unknown';

					                      if (member.type) {
						                      switch (member.type) {
							                      case 'staff': {
								                      type = 'Staff Members';

								                      break;
							                      }

							                      case 'support-worker': {
								                      type = 'Support Workers';

								                      break;
							                      }
						                      }
					                      }

					                      let photoUrl = `https://www.gravatar.com/avatar/${member.emailHash}?d=mm`;

					                      if (member.photoId) {
						                      photoUrl = `${process.env.API_ENDPOINT}photos/${member.photoId}/download?token=${AuthService.getToken()}`;
					                      }

					                      return {
						                      ...member,
						                      type,
						                      photoUrl,
					                      };
				                      });
			};

			OnlineUsersService.onUpdate(scope.update);

			scope.update();
		},
	};
};


// WEBPACK FOOTER //
// ./src/js/directives/onlineUsers/index.js